import type { Value } from "platejs";

/**
 * Decide the editor value when appending macro/AI-generated content. When the
 * editor is empty we replace outright (so there's no leading blank paragraph);
 * otherwise we append after the existing content so an in-progress reply is
 * never discarded.
 *
 * `isEmpty` is supplied by the live editor's own emptiness check so this stays
 * consistent with how the editor renders "empty". Kept free of any `platejs`
 * runtime import (type-only) so it stays unit-testable under Jest — platejs is
 * ESM and cannot be `require()`d.
 */
export function mergeAppendedValue(
  current: Value,
  incoming: Value,
  isEmpty: boolean,
): Value {
  return isEmpty ? incoming : [...current, ...incoming];
}
